import { render, staticRenderFns } from "./CustomDialogActionButtonsComponent.vue?vue&type=template&id=2bf5706a&scoped=true&lang=pug"
import script from "./CustomDialogActionButtonsComponent.vue?vue&type=script&lang=ts"
export * from "./CustomDialogActionButtonsComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomDialogActionButtonsComponent.vue?vue&type=style&index=0&id=2bf5706a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5706a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf5706a')) {
      api.createRecord('2bf5706a', component.options)
    } else {
      api.reload('2bf5706a', component.options)
    }
    module.hot.accept("./CustomDialogActionButtonsComponent.vue?vue&type=template&id=2bf5706a&scoped=true&lang=pug", function () {
      api.rerender('2bf5706a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue"
export default component.exports